import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Mail.svg",
  "use": "Mail.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Mail.svg\"><path d=\"M33.685,37.517a3,3,0,0,1-3.3283,0l-21-14a3,3,0,0,1-1.3359-2.4962v-2a3,3,0,0,1,3-3h42a3,3,0,0,1,3,3v2a2.9993,2.9993,0,0,1-1.3358,2.4962Zm22.3357,7.5038a3,3,0,0,1-3,3h-42a3,3,0,0,1-3-3v-17.78a1.2047,1.2047,0,0,1,1.8744-1.0015L29.2474,39.1811a5,5,0,0,0,5.5468,0L54.1463,26.239A1.2047,1.2047,0,0,1,56.0207,27.24Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol